import { render, staticRenderFns } from "./VTextUrl.vue?vue&type=template&id=5be3f468&"
import script from "./VTextUrl.vue?vue&type=script&lang=js&"
export * from "./VTextUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports